import api from './api';

export const getUsers = (page, params) => {
  return api.get('admin/User', { params: { page: page, limit: 5, ...params } });
};

export const registerUser = user => {
  const userInformation = {
    email: user.email,
    userName: user.authorName,
    channelName: user.channelName,
    channelAuthorName: user.authorName,
    channelSlug: user.slug,
  };

  return api.post('/admin/create_user', userInformation);
};

export const updateUser = (userId, update) => {
  return api.put(`admin/User/item/${userId}`, { object: update });
};

export const deleteUser = uid => {
  return api.delete(`/user/${uid}`);
};

export const clearCacheCloudFront = () => {
  return api.get('/admin/cloudfront/invalidate');
};
